module.exports = __webpack_public_path__ + "img/over.b56a20ef.png";